<div class="contract-widget d-flex h-100 p-3 align-items-center">
    <div class="m-auto">
        <span class="d-none d-lg-block title">{{ contract?.getTypeProperties(contract.getType()).name | translate }}</span>
        <a class="d-flex align-items-center" (click)="showContractList(true)">
            <span class="d-inline-block d-lg-none title ">{{ contract?.Nickname }}</span>
            <span class="d-inline-block ml-2 d-lg-none" *ngIf="!isSingleContract">
                <i class="icon-edponline-Bop-073 rotate-270 icon-size align-middle"  aria-hidden="true"></i>
            </span>
        </a>
        <span class="d-block detail">{{ contract?.getBasicComponentAddress(0).toString() | titlecase }}</span>
    </div>
    <div class="m-auto">
            <i class="{{ contract?.getTypeProperties(contract.getType()).iconBop }} icon-contract" [ngClass]="{'color-inactive-contract': !contract.isActivo() || contract.isInActivation()}"  aria-hidden="true"></i>
    </div>
</div>
